var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"events-list"},_vm._l((_vm.events),function(event,index){return _c('card-event',{key:("" + (JSON.stringify(event)) + index),attrs:{"event":event}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }